/*
 * action types
 */

export enum ActionType {
	//Loading Actions
	LOAD_STATE_FROM_STORAGE,
	REQUEST_RESULTS,
	RECEIVE_RESULTS,

	//Pagination Actions
	CHANGE_LENGTH,
	NEXT_PAGE,
	PREVIOUS_PAGE,
	JUMP_TO_PAGE,

	//Filter Actions
	UPDATE_KEYWORD,
	INIT_KEYWORD,
	UPDATE_FACET,
	INIT_FACET
}